import React from "react";

import { Alert, Snackbar } from "@mui/material";

import { AlertColor } from "@/util/constants";

interface SnackBarProps {
  alertOpen: boolean;
  color: AlertColor;
  message: string;
  handleAlertClose: () => void;
  style?: Object;
}

export const Alerts: React.FC<SnackBarProps> = ({
  handleAlertClose,
  alertOpen,
  message,
  color,
  style,
}) => {
  return (
    <Snackbar
      open={alertOpen}
      autoHideDuration={6000}
      onClose={handleAlertClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      style={style}
    >
      <Alert
        onClose={handleAlertClose}
        severity={color}
        variant="filled"
        sx={{ width: "100%" }}
        data-testid="alert"
      >
        {message}
      </Alert>
    </Snackbar>
  );
};
